import CategoriesCard from './CategoriesCard';

export default CategoriesCard;
